import { render, staticRenderFns } from "./StarterPromoCard.vue?vue&type=template&id=d501296c&"
import script from "./StarterPromoCard.vue?vue&type=script&lang=js&"
export * from "./StarterPromoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports